// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"76851960","117":"ead73e1f","127":"d4b2cdb3","189":"f2a36a7c","434":"d4b2cdb3","820":"c7970f29","917":"1b20271f"}[chunkId] + ".css";
};